import { loadHeicTo } from "@/hooks/useProprietaryHeicFiles/loadHeicTo.web";
import type { ResolveHeicUriParams } from "@/hooks/useProprietaryHeicFiles/types";

const isHeicContentType = (contentType?: string): boolean => {
  const lowerCased = contentType?.toLowerCase() ?? "";
  return lowerCased.includes("heic") || lowerCased.includes("heif");
};

const convertHeicToJpeg = async (blob: Blob): Promise<Blob> => {
  const heicTo = await loadHeicTo();
  return heicTo({ blob, quality: 0.9, type: "image/jpeg" });
};

// Fetches the source bytes, and if they are HEIC, returns a JPEG blob url;
// otherwise returns the original uri unchanged.
const resolveHeicUri = async ({
  contentType,
  uri,
}: ResolveHeicUriParams): Promise<string> => {
  const blob = await (await fetch(uri)).blob();
  const isHeic = isHeicContentType(contentType) || isHeicContentType(blob.type);
  if (!isHeic) return uri;

  const jpegBlob = await convertHeicToJpeg(blob);
  return URL.createObjectURL(jpegBlob);
};

export { isHeicContentType, resolveHeicUri };
